module.exports = __webpack_public_path__ + "img/two.4cfbc5f4.png";